import { useForm, useFormField } from '../modules/forms';

export interface RememberCardFormData {
  readonly rememberCard: boolean;
}

export interface RememberCardFormOptions {
  /**
   * Initial data to populate the form with.
   */
  readonly initialData?: RememberCardFormData;
  /**
   * Disable form.
   */
  readonly disabled?: boolean;
}

export function useAccountRememberCardForm(
  onSubmit: (data: RememberCardFormData) => void,
  options?: RememberCardFormOptions,
) {
  const { initialData, disabled } = options ?? {};

  const rememberCard = useFormField({
    value: initialData?.rememberCard ?? false,
    required: false,
    disabled,
  });

  const form = useForm({
    fields: {
      rememberCard,
    },
    onSubmit,
  });

  return form;
}
